const baseUrls = {
  loyaltyApiBaseUrl: `${process.env.REACT_APP_LOYALTY_API_GATEWAY_BASE_URL}/api/loyalty`,
  loyaltyUsersApiBaseUrl: `${process.env.REACT_APP_LOYALTY_API_GATEWAY_BASE_URL}/users/api`,
};

const urls = {
  common: {
    getConfigurations: `${baseUrls.loyaltyApiBaseUrl}/getconfigurations`,
  },
  accountManagementUrls: {
    authenticateUser: `${baseUrls.loyaltyUsersApiBaseUrl}/login`,
    getLoginInfo: `${baseUrls.loyaltyUsersApiBaseUrl}/users`,
  },
  membersUrls: {
    getusers: `${baseUrls.loyaltyApiBaseUrl}/getusers`,
    blockUser: `${baseUrls.loyaltyApiBaseUrl}/updateuserstatus`,
    getUserTransactions: `${baseUrls.loyaltyApiBaseUrl}/getusertransactions`,
    awardPoints: `${baseUrls.loyaltyApiBaseUrl}/earnpoints`,
    deductPoints: `${baseUrls.loyaltyApiBaseUrl}/deductpoints`,
  },
};

export default urls;
